var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wing-container",style:({
    'grid-template-rows': Array.from({ length: _vm.info.aircraftLength })
      .map(function () { return 'auto'; })
      .join(' '),
  })},[_c('div',{staticClass:"spacer",style:({
      'grid-row': '1 / ' + _vm.info.startWingsRow,
    })}),(_vm.info.valid)?_c('div',{staticClass:"wing-wrapper",style:({
      'grid-row': _vm.info.startWingsRow + ' / ' + _vm.info.endWingsRow,
    })},[_c('div',{class:'wing wing-' + _vm.info.direction})]):_vm._e(),_c('div',{staticClass:"spacer",style:({
      'grid-row': _vm.info.endWingsRow + ' / -1',
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }